import React from 'react'
import PropTypes from 'prop-types'
import moment from 'moment'
import useGlobals from 'sb-hooks/useGlobals'
import { useConnect } from 'sb-redux-hook'
import { useMedia, useFeatures } from 'sb-hooks'
import { array, constants, formatPrice } from 'common/helpers'

import Box from 'components/_new/layout/Box/Box'
import usePlansQuery from 'components/upgradePlans/usePlansQuery'
import ContentLoaderAwareOfRequestLoader from 'components/loaders/ContentLoaderAwareOfRequestLoader/ContentLoaderAwareOfRequestLoader'

import PickProduct from './PickProduct/PickProduct'
import MonthInfo from './MonthInfo/MonthInfo'


const PickProducts = ({ withPlan, dataTestId, itemDataTestId, onRemove }) => {
  const { [constants.features.billingDay1stDayOfTheMonth]: isBillingDay1stEnabled } = useFeatures()
  const { isMobile } = useMedia()
  const { priceWithDiscount } = useGlobals(({ globals }) => ({
    priceWithDiscount: globals.cookies[constants.cookieNames.priceWithDiscount],
  }))
  const { selectedPlan, selectedItems, selectedLandingItems } = useConnect({
    selectedPlan: 'view.paymentPage.selectedPlan',
    selectedItems: 'view.pickPage.selectedItems',
    selectedLandingItems: 'view.makeupLandingPage.selectedLandingItems',
  })
  const { plans } = usePlansQuery({
    billing: 1,
    shipping: 1,
  })

  if (!plans.length) {
    return (
      <ContentLoaderAwareOfRequestLoader />
    )
  }

  const { productsPerPeriod, productPrice, price } = plans.find(({ name }) => name === selectedPlan) || {}

  const monthDelimiter    = isBillingDay1stEnabled ? 17 : 21
  const selectedProducts  = selectedItems.length ? selectedItems : selectedLandingItems
  const isOneProductMonth = productsPerPeriod === 1

  const firstMonthProductPrice  = ({
    '$26.25': 875,
    '$18.75': 938,
    '$7.50': 375,
  })[priceWithDiscount] || 1495

  const currentYear   = new Date().getFullYear()
  const currentMonth  = new Date().getMonth()

  return (
    <div data-testid={dataTestId}>
      {
        array
          .toChunks(selectedProducts, productsPerPeriod)
          .map((chunk, index) => {
            const pomCount          = productsPerPeriod - chunk.length
            const productMonthIndex = new Date().getDate() <= monthDelimiter ? index : index + 1
            const productMonth      = currentMonth + productMonthIndex
            const yearIndex         = Math.floor(productMonth / 12)
            const monthNameIndex    = productMonth - 12 * yearIndex
            const year              = currentYear + yearIndex
            const month             = isMobile && isOneProductMonth
              ? moment.monthsShort()[monthNameIndex]
              : moment.months()[monthNameIndex]

            const productPriceValue = formatPrice(!index ? firstMonthProductPrice : productPrice, true, true)

            return (
              <Box key={index} pt={Boolean(index) && '16'}>
                {
                  Boolean(!isOneProductMonth) && (
                    <MonthInfo
                      month={month}
                      price={formatPrice(price, false, true)}
                      discountPrice={Boolean(!index) && priceWithDiscount}
                    />
                  )
                }
                {
                  chunk.map(({ id, name, brand, image, upchargePrice }, productIndex) => (
                    <div
                      key={productIndex}
                      data-testid={itemDataTestId}
                    >
                      <PickProduct
                        id={id}
                        name={name}
                        brand={brand}
                        image={image}
                        month={isOneProductMonth && month}
                        year={isOneProductMonth && year}
                        price={productPriceValue}
                        priceWithDiscount={isOneProductMonth && !index && priceWithDiscount}
                        upchargePrice={upchargePrice}
                        onRemove={onRemove}
                      />
                    </div>
                  ))
                }
                {
                  Boolean(pomCount) && (
                    array.range(1, pomCount).map((count) => (
                      <div
                        key={count}
                        data-testid={itemDataTestId}
                      >
                        <PickProduct
                          price={productPriceValue}
                        />
                      </div>
                    ))
                  )
                }
              </Box>
            )
          })
      }
    </div>
  )
}

PickProducts.propTypes = {
  // TODO rename this prop
  // this is to take plan into account while counting products timeline
  // for instance, if you have a MONTHLY_2PCS plan, you need to show that 2 products are coming this month
  withPlan: PropTypes.bool,
  onRemove: PropTypes.func,
  dataTestId: PropTypes.string,
  itemDataTestId: PropTypes.string,
}

PickProducts.defaultProps = {
  withPlan: false,
}


export default PickProducts
